import { FSA } from '@typings/redux';
import { call, CallEffect, fork, ForkEffect, put, takeLatest, select } from 'redux-saga/effects';
import { Action } from 'redux';
import { AuthActionType } from 'store/auth/auth.actionType';
import { ROUTE_AUTH_LOGIN } from 'config/routes';
import { fetchUserInfo } from 'store/user/user.action';
import { userId } from 'store/user';

export function* checkAuthSuccess(): IterableIterator<any> {
  // After successful authentication, fetch user data
  // User permissions and access rules will be fetched by user.saga.ts after user info is loaded
  const userIdValue = yield select(userId);
  if (!userIdValue) {
    yield put(fetchUserInfo() as unknown as Action);
  }
}

export function* checkAuthFailure(): IterableIterator<CallEffect> {
  yield call(() => {
    window.location.href = ROUTE_AUTH_LOGIN;
  });
}

export function* authSaga(): Iterator<ForkEffect> {
  yield fork(function* () {
    yield takeLatest(AuthActionType.CHECK_AUTH_SUCCESS, checkAuthSuccess);
  });
  yield fork(function* () {
    yield takeLatest(AuthActionType.CHECK_AUTH_FAILURE, checkAuthFailure);
  });
}
